import { Link } from "react-router-dom";
import { allCategories } from "@/lib/content";
import { toneBadge, toneDot } from "@/lib/tone";

export default function CategoryStrip() {
  return (
    <section aria-label="内容栏目" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-4 px-4 py-10 md:grid-cols-2 md:px-8 md:py-12 lg:grid-cols-4">
        {allCategories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex cursor-pointer flex-col rounded-xl2 border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
          >
            <span className="flex items-center justify-between">
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${toneDot[category.tone]} text-background-50`}>
                <i className={`${category.icon} text-xl`}></i>
              </span>
              <i className="ri-arrow-right-up-line text-foreground-300 transition-colors group-hover:text-primary-600"></i>
            </span>
            <span className="mt-4 flex items-center gap-2">
              <h2 className="font-heading text-lg font-bold text-foreground-950">{category.name}</h2>
              <span className={`rounded-full border px-2 py-0.5 text-[11px] ${toneBadge[category.tone]}`}>栏目</span>
            </span>
            <span className="mt-2 text-sm leading-relaxed text-foreground-600">{category.description}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}